"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = exports.getFixed = exports.getRect = exports.getTarget = void 0;
var tslib_1 = require("tslib");
var inject_value_1 = require("../_util/inject-value");
function getTarget(target) {
    return inject_value_1.injectValue(target)() || window;
}
exports.getTarget = getTarget;
function getRect(target) {
    if (target && target !== window) {
        return target.getBoundingClientRect();
    }
    return {
        top: 0,
        bottom: window.innerHeight,
        left: 0,
        right: window.innerWidth,
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
exports.getRect = getRect;
function getFixed(target, placeholder, offset, isTop) {
    if (isTop === void 0) { isTop = true; }
    if (typeof offset === "undefined") {
        return undefined;
    }
    var targetElement = getRect(getTarget(target));
    if (isTop && targetElement.top > getRect(placeholder).top - offset) {
        return offset + targetElement.top;
    }
    if (!isTop && targetElement.bottom < getRect(placeholder).bottom + offset) {
        return offset + window.innerHeight - targetElement.bottom;
    }
    return undefined;
}
exports.getFixed = getFixed;
function throttle(fn) {
    var rafId;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!rafId) {
            rafId = requestAnimationFrame(function () {
                rafId = null;
                fn.apply(void 0, tslib_1.__spread(args));
            });
        }
    };
}
exports.throttle = throttle;
//# sourceMappingURL=util.js.map